import React from 'react';

const StatsSection: React.FC = () => {
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="max-w-content mx-auto px-6">
        <h3 className="font-exo font-bold text-ebony-clay text-xl lg:text-2xl tracking-[1.2px] leading-normal text-center mb-8">
          Trusted by Businesses Worldwide
        </h3>
        <div className="grid grid-cols-2 md:flex md:flex-wrap md:justify-center gap-8 lg:gap-16">
          <div className="text-center">
            <div className="font-exo font-semibold text-royal-blue text-2xl lg:text-[32px] tracking-[1.6px] leading-normal">
              15+
            </div>
            <div className="font-exo font-semibold text-eerie-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2">
              Years of Excellence
            </div>
          </div>
          <div className="text-center">
            <div className="font-exo font-semibold text-royal-blue text-2xl lg:text-[32px] tracking-[1.6px] leading-normal">
              100s
            </div>
            <div className="font-exo font-semibold text-eerie-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2">
              Projects Delivered
            </div>
          </div>
          <div className="text-center">
            <div className="font-exo font-semibold text-royal-blue text-2xl lg:text-[32px] tracking-[1.6px] leading-normal">
              0
            </div>
            <div className="font-exo font-semibold text-eerie-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2">
              Undocumented Features
            </div>
          </div>
          <div className="text-center">
            <div className="font-exo font-semibold text-royal-blue text-2xl lg:text-[32px] tracking-[1.6px] leading-normal">
              100%
            </div>
            <div className="font-exo font-semibold text-eerie-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2">
              Code Peer-reviewed
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
